export const SetAuthToken=token=>{
    localStorage.setItem("token",token);
}
export const GetAuthToken=()=>{
    return localStorage.getItem("token")
}

export const Redirect_Suppliers="REDIRECT_SUPPLIERS"
export const Redirect_Initial_Companies="REDIRECT_INITIAL_COMPANIES"

// Always returns an array. Used by FinalStepPayment.RedirectFuncLogic to
// re-hydrate initialCompanies after a Stripe redirect (3DS / PayPal). The
// callers branch on `.length`, so a non-array result silently misroutes
// the add-more-services flow into creating a fresh MoveinInfo and
// orphaning the prior one — see issue #53.
export const readInitialCompaniesFromStorage = () => {
  const raw = localStorage.getItem(Redirect_Initial_Companies);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};